// Aviso con la tarjeta de prueba de CuboPago. Solo se muestra en el entorno de
// pruebas (VITE_ENV_LABEL definido); nunca en producción.
const TEST_CARD = {
  number: "4000 0000 0000 0416",
  expiry: "12/28",
  cvv: "123",
  phone: "+507 6123 4567",
};

export const TestCardNotice = () => {
  if (!import.meta.env.VITE_ENV_LABEL) return null;

  return (
    <div
      data-testid="test-card-notice"
      className="rounded-md border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
    >
      <p className="font-semibold">Entorno de pruebas — sin cobros reales</p>
      <p className="mt-1">Usá esta tarjeta de prueba para completar la compra:</p>
      <ul className="mt-2 space-y-0.5 font-mono">
        <li>Tarjeta: {TEST_CARD.number}</li>
        <li>Vencimiento: {TEST_CARD.expiry}</li>
        <li>CVV: {TEST_CARD.cvv}</li>
        <li>Teléfono: {TEST_CARD.phone}</li>
      </ul>
    </div>
  );
};
